import React from 'react'
import { HStack, Tag, Text } from '@chakra-ui/react'
import { ValidationError } from './types'
import { SurfaceTextDiff } from '../SurfaceTextDiff'

interface EncoderValidationErrorsProps {
    formikError: string | undefined
    serverErrors: ValidationError[]
    touched: boolean
    textEncoding: string
    westernScript: boolean
    originalBody: string
    currentValue: string
    showErrorsByDefault: boolean
}

export const EncoderValidationErrors: React.FC<
    EncoderValidationErrorsProps
> = ({
    formikError,
    serverErrors,
    touched,
    textEncoding,
    westernScript,
    originalBody,
    currentValue,
    showErrorsByDefault,
}) => {
    // Show formik errors when touched OR when showErrorsByDefault is enabled
    const showFormikError =
        formikError &&
        (touched || showErrorsByDefault) &&
        textEncoding === 'syriacetcbc'

    // Always show server errors when they exist OR when showErrorsByDefault is enabled
    const shouldShowServerErrors = showErrorsByDefault || serverErrors.length > 0

    return (
        <>
            {/* Formik validation error with preview */}
            {showFormikError && (
                <>
                    <Tag>Preview:</Tag>
                    <SurfaceTextDiff
                        westernScript={westernScript}
                        surfaceText={originalBody}
                        newProposedValue={currentValue}
                    />
                    <Text
                        color="red"
                        align="center"
                        fontSize="small"
                        mt="2"
                    >
                        {formikError}
                    </Text>
                </>
            )}

            {/* Server validation errors */}
            {shouldShowServerErrors &&
                serverErrors.map((error, index) => (
                    <Text
                        key={index}
                        color="red"
                        align="center"
                        fontSize="small"
                        mt="2"
                        backgroundColor="#ffffff"
                        border="1px solid #c6d1db"
                        p="0.5rem 1.5rem 0.5rem 1rem"
                        borderRadius="2rem"
                    >
                        <HStack>
                            <span
                                style={{
                                    backgroundColor: '#faebd7',
                                    borderRadius: '1rem',
                                    padding: '0.5rem 1rem',
                                }}
                            >
                                {error.code}
                            </span>
                            <span>
                                {error.error.replace('analyse: ', '')}
                            </span>
                        </HStack>
                    </Text>
                ))}
        </>
    )
}
